<div class="media d-flex align-items-center">
    <a [routerLink]="['/shop/products/', product.id]">
        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
            [lazyLoad]="ImageSrc ? ImageSrc : product.images[0].imageUrl" class="img-fluid lazy-loading"
            alt="{{ product.images[0].id }}">
    </a>
    <div class="media-body align-self-center">
        <div class="rating">
            <bar-rating [rate]="product.averageRating" [readOnly]="true"></bar-rating>
        </div>
        <div class="product-link-name">
            <a [routerLink]="['/shop/products/', product.id]">
                {{ product?.name.length > 20 ? product?.name.slice(0, 20) + '...' :
                product?.name | titlecase }}
            </a>
        </div>
        <h4>{{ product?.cost - (product.cost * product.discountPercent / 100 ) | currency:'VND'}}</h4>
        <!-- <ul class="color-variant">
            <li [class]="color" 
                *ngFor="let color of Color(product?.categories)"
                [ngStyle]="{'background-color': color}"
                (click)="ChangeVariants(color, product)">
            </li>
        </ul> -->
    </div>
</div>